import React, { useRef, useState } from "react";
import "./contact.css";
import { FaPhone, FaEnvelope, FaDownload } from "react-icons/fa";
import Socials from "../Socials/Socials";
import emailjs from "emailjs-com";

const Contact = () => {
  const formRef = useRef();
  const [done, SetDone] = useState(false);

  const SubmitHandler = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_bd8yafo",
        "template_gkngc3a",
        formRef.current,
        "user_enQpnH8nsOJMTWNKRCELa",
      )
      .then(
        (result) => {
          console.log(result.text);
          SetDone(true);
        },
        (error) => {
          console.log(error.text);
        },
      );
  };
  return (
    <div className="c" id="contact">
      <div className="bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <p className="topLine">contact</p>

          <h1 className="title">Let's talk about your project</h1>
          <div className="info">
            <div className="info-item">
              <FaPhone className="icon" />
              +256 750 730 118 <br />
              +256 72 639 8777
            </div>
            <div className="info-item">
              <FaEnvelope className="icon" />
              earlvunifred@gmail.com fredvuni809@gmail.com
            </div>
            <div className="info-item">
              <a
                download
                href={require("../resume/resume.pdf").default}
                className="download"
              >
                {" "}
                <FaDownload className="d-icon" /> Download Resume
              </a>
            </div>
          </div>
          <Socials className="socials" />
        </div>
        <div className="c-right">
          <p className="desc">
            <b>What's your story ? </b>
            Get in touch. I'm Always Freelancing if the right project comes
            along.
          </p>
          <form ref={formRef} onSubmit={SubmitHandler}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Enter your name"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter your email address"
                required
              />
            </div>
            <div className="form-group">
              <select
                className="form-control custom-select"
                name="subject"
                id="subject"
                required=""
                data-msg="Please select your subject / budget."
              >
                <option value="none" selected="" disabled="">
                  Budget / subject
                </option>
                <option value="I just have an inquiry">
                  I just have an inquiry
                </option>
                <option value="None, just getting started">
                  None, just getting started
                </option>
                <option value="Less than $200">Less than $200</option>
                <option value="$200 to $500">$200 to $500</option>
                <option value="$500 to $1,0000">$500 to $1,000</option>
                <option value="More than $1,000">More than $1,000</option>
              </select>
            </div>
            <div className="form-group">
              <textarea
                className="form-control"
                rows="5"
                name="message"
                id="message"
                placeholder="Tell me more about your project, needs, and timeline or just make an inquiry"
                aria-label="Tell me more about your project, needs, and timeline or just make an inquiry."
                required=""
                data-msg="Please enter a reason."
              ></textarea>
            </div>
            <div className="form-group">
              <button type="submit" className="btn">
                Send message
              </button>
            </div>
          </form>
          {done && (
            <div className="alert alert-success">
              Your message has been sent.Thank you,i'll get back to you as soon
              as i can.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
